<template>
  <div class="col-md-12">
    <time-line>
      <time-line-item class="timeline-inverted" badgeType="danger" badgeIcon="ti-pin2">
        <span slot="header" class="label label-danger">University of Virginia</span>
        <p slot="job-title" class="job-title" >Member of the S<sup>2</sup>He Lab</p>
        <p slot="dates" class="dates">(Aug 2019 - Present)</p>
        <p slot="body">
          The Sensing Systems for Health Lab fuses computational methods with technology such as smartphones and wearables to design intelligent systems for understanding the dynamics and personalization of health and well-being.</p>
      </time-line-item>

      <time-line-item badgeType="green" badgeIcon="ti-pin2">
        <span slot="header" class="label label-green">MedRhythms, Inc.</span>
        <p slot="job-title" class="job-title" >Software Development Intern</p>
        <p slot="dates" class="dates">(May 2019 - Aug 2019)</p>
        <p slot="body">
          MedRhythms is a digital therapeutics company that uses sensors, music, and AI to build evidence-based neurologic interventions to measure and improve walking.</p>
      </time-line-item>

      <time-line-item class="timeline-inverted" badgeType="red" badgeIcon="ti-pin2">
        <span slot="header" class="label label-red">University of Utah</span>
        <p slot="job-title" class="job-title" >Member of the QED Lab</p>
        <p slot="dates" class="dates" >(Aug 2018 - Aug 2019)</p>
        <p slot="body">
          The QED (Quantitative Experience Design) Lab is an interdisciplinary research group at the University of Utah. The lab builds human-centered artificial intelligence systems in search of invariant properties of experience design: precise relationships that exist between an inner environment (a person’s cognitive states), interface (narrative and game discourse) and outer environment (virtual worlds).</p>
      </time-line-item>

      <time-line-item badgeType="gold" badgeIcon="ti-pin2">
        <span slot="header" class="label label-gold">Sensit Technologies</span>
        <p slot="job-title" class="job-title" >Software and Full Stack Developer</p>
        <p slot="dates" class="dates" >(Jan 2018 - Aug 2019)</p>
        <p slot="body">
            <ul>
                <li>Designed and developed numerous web applications with Angular, Vue, Node.js, and PHP using Azure for production deployments</li>
                <li>Migrated backend of fixed-point laser field methane detector from PHP to Node.js as well as database usage from MySQL to Microsoft SQL Server 2018</li>
            </ul>
        </p>
      </time-line-item>

      <time-line-item class="timeline-inverted" badgeType="brown" badgeIcon="ti-pin2">
        <span slot="header" class="label label-brown">Valparaiso University</span>
        <p slot="job-title" class="job-title" >Hesse Center Tutor</p>
        <p slot="dates" class="dates" >(Aug 2013 - Dec 2017)</p>
        <p slot="body">
            <ul>
                <li>Led multiple ECE course recitations including linear circuit theory and digital logic</li>
                <li>Facilitated, constructed, and graded labs for introductory circuit design courses</li>
            </ul>
        </p>
      </time-line-item>

      <time-line-item badgeType="gold" badgeIcon="ti-pin2">
        <span slot="header" class="label label-gold">Sensit Technologies</span>
        <p slot="job-title" class="job-title" >Summer Intern</p>
        <p slot="dates" class="dates" >(May 2017 - Aug 2017)</p>
        <p slot="body">
            <ul>
                <li>Designed, developed, and deployed full web app utilizing Angular for a fixed-point laser field methane detector prototype to help customers track gas leaks in various oil fields</li>
                <li>Created mobile app counterpart on native iOS, Android, and Windows platforms using Ionic framework</li>
            </ul>
        </p>
      </time-line-item>

      <time-line-item class="timeline-inverted" badgeType="info" badgeIcon="ti-pin2">
        <span slot="header" class="label label-info">Michigan City Career Center</span>
        <p slot="job-title" class="job-title" >Lecturer and Lead App Developer</p>
        <p slot="dates" class="dates" >(Oct 2016 - Nov 2016)</p>
        <p slot="body">
            <ul>
                <li>Facilitated the development and implementation of an Android and web application to help promote robotics clubs within the community for a First Robotics Club</li>
                <li>Gathered necessary resources for lessons, tailored teaching style for optimal retention of skills, and provided a classroom environment conducive to learning</li>
            </ul>
        </p>
      </time-line-item>

    </time-line>
  </div>

<!-- <time-line-item class="timeline-inverted" badgeType="info" badgeIcon="ti-credit-card">
        <span slot="header" class="label label-success">Another Title</span>
        <div slot="body">
          <p>
            Called I Miss the Old Kanye That’s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM</p>
          <p>
            What if Kanye made a song about Kanye Royère doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn’t any Kanyes Set on his goals Kanye</p>
          <hr>
          <drop-down class="btn-group">
            <button slot="title" href="#" type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown">
              <i class="ti-settings"></i> <span class="caret"></span>
            </button>
            <li><a href="#action">Action</a></li>
            <li><a href="#action">Another action</a></li>
            <li><a href="#here">Something else here</a></li>
            <li class="divider"></li>
            <li><a href="#link">Separated link</a></li>
          </drop-down>
        </div>
        <h6 slot="footer">
          <i class="ti-time"></i>
          11 hours ago via Twitter
        </h6>
      </time-line-item> -->
</template>
<script>
  import TimeLine from './Dashboard/Stats/TimeLine.vue'
  import TimeLineItem from './Dashboard/Stats/TimeLineItem.vue'

  export default {
    components: {
      TimeLine,
      TimeLineItem
    }
  }
</script>
<style>
.job-title {
    font-size: 17px;
}
.dates {
    font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/Experience.vue